import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { getAllUpgrades, isIncompleteUpgrade } from './api';
import List from './List';

class UpgradeListPage extends Component {
  constructor() {
    super();
    this.state = {
      items: [],
      error: false,
    };
  }
  async componentDidMount() {
    try {
      const items = await getAllUpgrades();
      this.setState({ items });
      this.setState({ error: false });
    } catch (err) {
      this.setState({ error: true });
    }
  }
  render() {
    const { items } = this.state;
    const imageHeight = 60;

    const columns = [
      {
        Header: 'Image',
        id: 'image',
        accessor: item => (
          <Link to={`/upgrades/${item._id}`}>
            <LazyLoad height={imageHeight} offset={100}>
              <img alt={item.name} src={item.image} height={imageHeight} />
            </LazyLoad>
          </Link>
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
        filterable: true,
      },
      {
        Header: 'Slots',
        accessor: 'slots',
        filterable: true,
      },
      {
        Header: 'Text',
        id: 'text',
        accessor: item => (item.text ? `✓` : `?`),
      },
      {
        Header: ' ',
        id: 'edit',
        accessor: item => (
          <Link to={`/upgrades/${item._id}`}>
            <button type="button" className="btn btn-info">
              Edit
            </button>
          </Link>
        ),
      },
    ];

    items.sort((a, b) => {
      if (isIncompleteUpgrade(a)) return -1;
      if (isIncompleteUpgrade(b)) return 1;
      return 0;
    });

    return (
      <div className="UpgradeListPage">
        {!items.length ? <span>Loading...</span> : <List data={items} columns={columns} />}
        {/* <table className="table">
          <thead>
            <tr>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Slots</th>
              <th scope="col">Text</th>
              <th scope="col" />
            </tr>
          </thead>
          <tbody>
            {!this.state.error &&
              items.length === 0 && (
                <tr>
                  <td colSpan="7">Loading...</td>
                </tr>
              )}
            {items.map((item, i) => (
              <tr key={item._id || item.image || i}>
                <td>
                  <Link to={`/upgrades/${item._id}`}>
                    <LazyLoad height={imageHeight} offset={100}>
                      <img alt={item.name} src={item.image} height={imageHeight} />
                    </LazyLoad>
                  </Link>
                </td>
                <td>
                  {item.name ? (
                    <Link to={`/upgrades/${item._id}`}>
                      {item.unique && '•'}
                      {item.name}
                    </Link>
                  ) : (
                    `?`
                  )}
                </td>
                <td>{item.Slots || `?`}</td>
                <td>{item.text ? `✓` : `?`}</td>
                <td>
                  <Link to={`/upgrades/${item._id}`}>
                    <button type="button" className="btn btn-info">
                      Edit
                    </button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
        {this.state.error && (
          <div className="alert alert-danger" role="alert">
            <strong>Oh no!</strong> Something went wrong :( Please try refreshing the page or come
            back later.
          </div>
        )}
      </div>
    );
  }
}

export default UpgradeListPage;



// WEBPACK FOOTER //
// ./src/UpgradeListPage.js